export default __webpack_public_path__ + "static/media/IBM.efec8b96.png";